// src/pages/RefundPolicy.js
import React from "react";
import InfoPageLayout from "./InfoPageLayout";
import ContentSection from "./ContentSection";

// Define the content for the page in a structured array
const refundData = [
  {
    type: "p",
    content:
      "Last updated: [Date]. At Xenford, we want to ensure our customers have a satisfying experience with TimeWise. This policy outlines the terms regarding refunds for our services.",
  },

  { type: "h2", content: "1. Subscription Services" },
  {
    type: "p",
    content:
      "TimeWise may be offered on a subscription basis (e.g., monthly or annually). As a general rule, all subscription fees are non-refundable.",
  },
  {
    type: "p",
    content:
      "When you cancel a subscription, you will continue to have access to the Service until the end of your current billing period. We do not provide prorated refunds for cancellations made partway through a billing cycle.",
  },

  { type: "h2", content: "2. New Customer Guarantee" },
  {
    type: "p",
    content:
      "We may offer a satisfaction guarantee for new customers. If such a guarantee is offered at the time of your purchase, you may be eligible for a full refund if you cancel your subscription and request a refund within the specified period (e.g., 7 or 14 days) of your initial purchase. This guarantee applies only to your first subscription with us.",
  },

  { type: "h2", content: "3. No Refunds For Certain Circumstances" },
  { type: "p", content: "We do not issue refunds for:" },
  {
    type: "ul",
    items: [
      "Partial subscription periods or unused time within a billing cycle.",
      "Service downtime or outages, though we will always work to resolve such issues promptly.",
      "Subscription renewals. It is the customer's responsibility to manage their subscription and cancel before the renewal date if they do not wish to continue.",
    ],
  },

  { type: "h2", content: "4. Exceptional Circumstances" },
  {
    type: "p",
    content:
      "Refunds outside of the stated policy may be considered on a case-by-case basis at the sole discretion of Xenford, typically in cases of significant billing errors or extended, unresolved service failures attributable to us.",
  },

  { type: "h2", content: "5. How to Request a Refund" },
  {
    type: "p",
    content:
      "To request a refund under our New Customer Guarantee or to report a billing issue, please contact our support team at support@xenford.com with your account details and the reason for your request.",
  },
];

const RefundPolicy = () => {
  return (
    <InfoPageLayout
      title="Refund Policy"
      subtitle="Our policy on refunds for subscriptions and services."
    >
      <ContentSection data={refundData} />
    </InfoPageLayout>
  );
};

export default RefundPolicy;
